import { FC, ReactNode, useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

import { Button } from 'components/Form/Button';

type SidebarHeaderConfig = {
  title: string;
};

type SidebarSectionProps = {
  children: ReactNode;
  header?: SidebarHeaderConfig;
};
export const SidebarSection: FC<SidebarSectionProps> = ({ children, header }) => {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <section aria-label={header?.title}>
      {header ? (
        <div className="flex items-center">
          {header.title ? <h1 className="text-xs text-gray-500">{header.title}</h1> : null}
          <Button
            size="extra-small"
            variant="minimal"
            className={collapsed ? '-rotate-90' : undefined}
            iconOnly
            LeftIcon={collapsed ? ChevronDownIcon : ChevronDownIcon}
            onClick={() => setCollapsed(!collapsed)}
            analyticsId="webedi:sidebar_section_toggle"
          />
        </div>
      ) : null}
      {collapsed ? null : <div className="mt-2">{children}</div>}
    </section>
  );
};
